
export default {
  name: 'TableListCol',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  vessel: {
    label: {
      marginBottom: 'xs',
      display: 'block',
      color: 'grey-dark',
    }
  }
}
